import {
  InvoiceLiteView,
  InvoiceView,
} from "admin/src/server/mappers/invoice/invoice";
import { ApiResponse } from "admin/src/ui/types/common/api-response";
import { ApiQueryConfig } from "api";
const GetInvoice: ApiQueryConfig<
  ApiResponse<InvoiceLiteView | InvoiceView>,
  {
    societyId: string;
    profileId: string;
    invoiceId: string;
  },
  Record<string, unknown>
> = {
  queryKey: {
    baseQueryKey: ["GetInvoices"],
    dynamicQueryKey: ["invoiceId"],
  },
  apiPath:
    "/api/v1/society/{societyId}/profiles/{profileId}/invoice/{invoiceId}",
};

export { GetInvoice };
